import { Navigate, Outlet } from 'react-router-dom';

export default function AuthGuard() {
    const isAuthenticated = !!localStorage.getItem('wp_jwt');
    return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
}
